/**
 * Keeps Tab and Shift+Tab inside an open panel: the drawer and every dialog.
 */

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** Visible focusable elements inside a container, in DOM order. */
export function focusables(container) {
	return Array.from(container.querySelectorAll(FOCUSABLE)).filter(
		(el) => el.offsetParent !== null || getComputedStyle(el).position === 'fixed'
	);
}

/** Call from a keydown listener on the container. Wraps first and last. */
export function trapFocus(container, event) {
	if (event.key !== 'Tab') return;
	const items = focusables(container);
	if (!items.length) {
		event.preventDefault();
		container.focus();
		return;
	}
	const first = items[0];
	const last = items[items.length - 1];
	if (event.shiftKey && (document.activeElement === first || document.activeElement === container)) {
		event.preventDefault();
		last.focus();
	} else if (!event.shiftKey && document.activeElement === last) {
		event.preventDefault();
		first.focus();
	}
}
